export default {
	ICON_STATUS_ENCODING: 1,
	ICON_STATUS_PROCESSING_SCREENSHOT: 2,
	ICON_STATUS_DONE: 3,
	ICON_STATUS_ERROR: 4,
	ENTITY_ICON_TYPE_DEFAULT: 0,
	ENTITY_ICON_TYPE_REFERENCE_MEDIA: 1,
}
